import { useSearchParams } from 'react-router';
import { LimitedCompanyScreen } from './LimitedCompanyScreen';

/**
 * Angular LimitedcompanyFRS102Component: `/home/settings/limited-company-FRS102` (no lightbulb, no paddings).
 * BUG-066: `?section=1A` is the FRS 102 Section 1A (small entities) screen - same layout, its own stored lists and notes.
 */
export function LimitedcompanyFRS102() {
  const [params] = useSearchParams();
  const settingsKey = params.get('section') === '1A' ? 'limited-frs102-1a' : 'limited-frs102';
  return <LimitedCompanyScreen key={settingsKey} settingsKey={settingsKey} padded={false} />;
}
